import React,{useState, useRef, Fragment} from "react";
import HoverButton from "../buttons/HoverButton";
import invitationsApi from '../api/invitationsAPI';
import {ErrorMessage, Loader, TextareaField, ErrorTooltip} from "react-fields";
import PopUp from "../base/popup";
import ErrorTooltipHtml from './ErrorTooltipHtml';
import {FadeInSection} from "../../components/fadeIn";
import {renderToStaticMarkup} from "react-dom/server";
import AccessCodeArea from "./code";


export default function Form(props) {

    const [educator, setEducator] = useState(props.educator);
    const [textEmails, setTextEmails] = useState("");
    const [emails, setEmails] = useState([]);
    const [emailErrors, setEmailErrors] = useState({});
    const [sentInvitations, setSentInvitations] = useState(0);
    let [isLoading, setLoading] = useState(false);

    const sentInvitationsRef = useRef(null);
    const copyTextareaRef = useRef(null);

    const onChange = (e) => {
        let value = e.target.value;
        value = value.replace(/'|"/g,'');
        let emails = value.split(/\s+|,|;/).filter(n => n);
        setEmails(emails);
        setTextEmails(value);
    };

    const invite =() => {
        if(!emails.length || emails.length > educator.available_licenses) {
            return;
        }
        setLoading(true);
        invitationsApi.sendInvitations(emails).then((response) => {
            if (Object.keys(response.errors)){
                setEmailErrors(response.errors);
                let emails = Object.keys(response.errors);
                setEmails(emails);
                setTextEmails(emails.join('\n'));
                setEducator(response.educator);
                setLoading(false);
                if(response.sent_emails > 0) {
                    setSentInvitations(response.sent_emails);
                    sentInvitationsRef.current.open();
                }

            }

        }).catch(error => {
            console.log(error);
            error.json().then((value) => {

            });
        });
    };

    return (
        <FadeInSection>
            <div className="grid-container transparent">
                <div className="grid-x align-center">
                    <div className="large-5 s-large-7 medium-12 cell">
                        <div className="grid-x">
                            <div className="small-12 cell">
                                <h1 className="mar-bot-20">Licenses</h1>
                            </div>
                            <div className="licenses__details small-4 cell">
                                <h3 className="licenses__title licenses__title--fixed-width">Used licenses</h3>
                                <h3 className="licenses__num">
                                    {educator.used_licenses}
                                </h3>
                            </div>
                            <div className="licenses__details small-4 cell">
                                <h3 className="licenses__title licenses__title--fixed-width">Available licenses</h3>
                                <h3 className="licenses__num licenses__num--grey">
                                    {educator.available_licenses}
                                </h3>
                            </div>
                            <div className="licenses__details small-4 cell grid-end">
                                <h3 className="licenses__title licenses__title--grey-off licenses__title--fixed-width">Pending Invites</h3>
                                <h3 className="licenses__num licenses__num--grey-off">
                                    {educator.pending_licenses}
                                </h3>
                            </div>
                        </div>
                        <div className="grid-x">
                            {!!educator.access_code ?
                                <AccessCodeArea accessCode={educator.access_code} />
                                :
                                <div className="small-8 cell mar-top-30 mar-bot-20">
                                    <h3 className="licenses__title">Invite users by email</h3>
                                </div>
                            }

                            <div className="small-4 cell flex-end text-right">
                                {emails.length > 0 ? <p style={{margin:'10px 0 0 0'}}>{emails.length}</p> : null}
                            </div>

                            <div className={'small-12 cell'} style={{position: 'relative'}}>
                                <TextareaField rows="10" value={textEmails}
                                               placeholder={'Enter emails one per line or separate with commas'}
                                          errorMessage={emails.length && emails.length > educator.available_licenses ? 'You have exceeded your available number of licenses' : null}
                                          onChange={onChange}
                                          className="vertical-resize licenses__emails"/>
                                {Object.keys(emailErrors).length ?
                                    <div className={'licenses__errors'}>
                                        <div className={'error error__main'}>
                                            {Object.keys(emailErrors).length} email address{Object.keys(emailErrors).length > 1 ? 'es' : ''} contain errors
                                        </div>
                                        <ErrorTooltip message={ Object.keys(emailErrors).map((email) => {return <div>{email} - {emailErrors[email].email}</div>})}/>

                                    </div> : null }
                            </div>
                        </div>
                        <div className="grid-x mar-bot-40">
                            <HoverButton onClick={invite}>
                                Invite users
                            </HoverButton>
                        </div>
                        <div className="grid-x">
                            <div className="small-12 cell">
                                <p className="licenses__title">Want to invite more users? <a href='/group/checkout'>Purchase licenses</a></p>
                            </div>
                        </div>
                    </div>
                </div>
                <PopUp ref={sentInvitationsRef} onClose={() => {}}>
                    <div className="grid-x align-center">
                        <div className="cell text-center">
                            <h3 className='text-center mar-bot-10'>Invites sent!</h3>
                            <p className='popup__text'>
                                {sentInvitations} invitation(s) have been successfully sent via email. You can view the status and progress of all your invited users inside the Users table.
                            </p>
                        </div>
                    </div>

                </PopUp>
            </div>
            {isLoading ? <Loader /> : null}
        </FadeInSection>
    )

}